<div class="d-flex mb-3 w-100 overflow-auto">
  @if (modifiche && modifiche.length > 0) {
  <table class="table table-responsive table-striped">
    <thead>
      <tr>
        @if (hasSelection) {
        <th class="table-column-max-width" scope="col" style="font-size: 16px">
          <div class="form-check">
            <input class="form-check-input border-primary mt-2 mb-1" type="checkbox" value="" id="flexCheckDefault"
              (change)="$event ? masterSelectionAll() : null"
              [checked]="selection.hasValue() &&
                isAllSelected() &&
                modifiche &&
                modifiche.length > 0"
              [disabled]="!editable || !isCheckboxEnabled" />
          </div>
        </th>
        } @if (!isDettaglio) {
        <th class="table-column-max-width" scope="col" title="Risorsa">
          Risorsa
        </th>
        }
        <th class="table-column-max-width text-slate-800" scope="col" title="Intervallo date">
          Intervallo date
        </th>
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Commessa sorgente">
          Commessa sorgente
        </th>
        <!-- @if (attore == attori.ControllerCentrale || attore ==
          attori.ControllerBU) {
          <th class="table-column-max-width text-slate-800">
            Intervento sorgente
          </th>
        } -->
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Commessa destinazione">
          Commessa destinazione
        </th>
        @if (isDettaglio) {
        <th class="table-column-max-width text-slate-800">
          Intervento destinazione
        </th>
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Stato">
          Stato
        </th>
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Data ultima modifica">
          Data ultima modifica
        </th>
        }
        @if ([attori.ControllerCentrale, attori.CFO, attori.DirettoreGenerale].includes(attore) && !isDettaglio) {
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="UO Primo Livello">
          UO Primo Livello
        </th>
        }
        @if ([attori.ControllerCentrale].includes(attore) && !isDettaglio) {
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Utente approvatore">
          Utente approvatore
        </th>
        }
        <th class="table-column-max-width text-slate-800" role="button" scope="col" title="Data approvazione">
          Data approvazione
        </th>
        <th class="table-column-max-width text-slate-800" scope="col" [title]="isDettaglio ? 'Azioni' : 'Dettaglio'">
          {{ isDettaglio ? 'Azioni' : 'Dettaglio' }}
        </th>
      </tr>
    </thead>
    <tbody>
      @for (element of modifiche; let idx = $index; track idx) {
      <tr>
        @if (hasSelection) {
        <td>
          @if (element.idStatoApprovazioneRichiestaRettifica ===
          idStatoRichiestaRettifica.In_Approvazione) {
          <div class="form-check">
            <input class="form-check-input border-primary mt-2" type="checkbox" value="" id="flexCheckDefault"
              (change)="masterSelection(element)" [checked]="selection.hasValue() && selection.isSelected(element)" />
          </div>
          }
        </td>
        } @if (!isDettaglio) {
        <td class="table-column-max-width">
          <span class="fw-semibold" [title]="element.nomeRisorsa">
            {{ element.nomeRisorsa }}
          </span>
          <br />
          <span class="text-slate-700" [title]="element.matricola">
            {{ element.matricola }}
          </span>
        </td>
        }
        <td class="table-column-max-width text-slate-700">
          Da:
          <span class="fw-semibold">{{ element.dataDa }}</span>
          <br />
          A: <span class="fw-semibold">{{ element.dataA }}</span>
        </td>
        <td class="table-column-max-width text-slate-700">
          <span class="fw-semibold" [matTooltip]="element.descrizioneCommessaSorgente || ''">
            {{ element.descrizioneCommessaSorgente }}
          </span>
          <br />
          <span>
            {{ element.codiceCommessaSorgente }}
          </span>
        </td>
        <td class="table-column-max-width text-slate-700">
          <span class="fw-semibold" [matTooltip]="element.descrizioneCommessaDestinazione || ''">
            {{ element.descrizioneCommessaDestinazione }}
          </span>
          <br />
          <span>
            {{ element.codiceCommessaDestinazione }}
          </span>
        </td>
        @if (isDettaglio) {
        <td class="table-column-max-width text-slate-700">
          <span class="fw-semibold">
            {{ element.descrizioneInterventoDestinazione }}
          </span>
          <br />
          <span>
            {{ element.codiceInterventoDestinazione }}
          </span>
          @if (element.ruoloTagetik !== null && isDettaglio) {
          <br />
          <span [matTooltip]="element.ruoloTagetik ?? ''">
            Ruolo: {{ element.ruoloTagetik }}
          </span>
          }
        </td>
        <td class="table-column-max-width text-slate-700">
          <span [title]="element.descrizioneStatoRichiesta">
            {{ element.descrizioneStatoRichiesta }}
          </span>
        </td>
        <td class="table-column-max-width text-slate-700">
          <span [title]="element.dataModifica">
            {{ element.dataModifica }}
          </span>
        </td>
        }
        @if ([attori.ControllerCentrale, attori.CFO, attori.DirettoreGenerale].includes(attore) && !isDettaglio) {
        <td class="table-column-max-width text-slate-700">
          <span [matTooltip]="element.descrizioneUnitaOrganizzativaPrimoLivello ?? ''">
            {{ element.descrizioneUnitaOrganizzativaPrimoLivello }}
          </span>
        </td>
        }
        @if ([attori.ControllerCentrale].includes(attore) && !isDettaglio) {
        <td class="table-column-max-width text-slate-700">
          <span [matTooltip]="element.nomeApprovatore ?? ''">
            {{ element.nomeApprovatore }}
          </span>
        </td>
        }
        <td class="table-column-max-width text-slate-700">
          <span [title]="element.dataApprovazione">
            {{ element.dataApprovazione }}
          </span>
        </td>
        <td class="table-column-max-width">
          <div class="d-flex align-items-center">
            @if (element.idStatoRichiesta ==
            idStatoRichiestaRettifica.Bozza && isDettaglio) {
            <a class="text-decoration-none" (click)="onIconClick(element, 'modifica')" onclick="return false"
              matTooltip="Modifica richiesta" href="/">
              <i class="bi bi-pencil-fill fs-5 me-2"></i>
            </a>
            <a class="text-decoration-none" (click)="onIconClick(element, 'rimuovi')" onclick="return false"
              matTooltip="Rimuovi richiesta" href="/">
              <i class="bi bi-trash-fill fs-5"></i>
            </a>
            } @if (!isDettaglio) {
            <a class="text-decoration-none" (click)="onIconClick(element, 'dettaglio')" onclick="return false"
              matTooltip="Dettaglio timesheet" href="/">
              <i class="bi bi-search fs-5 me-2"></i>
            </a>
            }
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>
  } @else {
  <p class="w-100 text-center">Nessuna richiesta presente</p>
  }
</div>
<div class="d-flex justify-content-between align-items-center">
  <span class="text-slate-700 ps-3 mb-3">
    {{
    elencoCount > 0
    ? elencoCount > 1
    ? elencoCount + " richieste trovate"
    : elencoCount + " richiesta trovata"
    : ""
    }}
  </span>

  <pagination *ngIf="totalPages > 0" alignment="end" [currentPage]="currentPage" [pageNumbers]="totalPages"
    [currentChanger]="pageOffset" (changerEvent)="changerEvent($event)" (pageEvent)="getPage($event)">
  </pagination>
</div>
